import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { PieChart, Pie, Cell,ResponsiveContainer } from 'recharts';
import { CategoryBreakdown, dashboardService } from '../../../services/dashboardService';

const data = [
  { name: 'Electricity', value: 120 },
  { name: 'Waste', value: 80 },
  { name: 'Water', value: 90 },
  { name: 'Waste Water', value: 66 },
];

const COLORS = ['#3B82F6', '#F59E0B', '#10B981', '#EF4444'];

interface DonutChartCardProps {
  categoryData: CategoryBreakdown;
}

const DonutChartCard: React.FC<DonutChartCardProps> = ({ categoryData }) => {
  // Convert category breakdown to chart data format
  const chartData = [
    { name: 'Electricity', value: categoryData.electricity },
    { name: 'Waste', value: categoryData.waste },
    { name: 'Water', value: categoryData.water },
    { name: 'Waste Water', value: categoryData.waste_water },
  ];

  const totalValue = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
  <Paper elevation={1} sx={{ 
    p: { xs: 2, sm: 3 }, 
    borderRadius: "12px",
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#fff',
    boxShadow: '0px 1px 3px rgba(0,0,0,0.1)'
  }}>
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography 
        fontWeight={600} 
        color='#1F2937'
        fontSize="20px"
      >
        Category
      </Typography>
      <Typography 
        fontSize="14px"
        color="#6B7280"
        fontWeight={500}
      >
        Last 6 months
      </Typography>
    </Box>
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', mt: 3 }}>
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '100%'
        }}
      >
        <Box 
          sx={{
            position: 'relative',
            width: '100%',
            height: { xs: '240px', sm: '260px', md: '280px' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                innerRadius={65}
                outerRadius={85}
                paddingAngle={4}
                dataKey="value"
                startAngle={90}
                endAngle={-270}
              >
                {chartData.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <Box
            position="absolute"
            top="50%"
            left="50%"
            sx={{ 
              transform: "translate(-50%, -50%)", 
              textAlign: "center"
            }}
          >
            <Typography 
              textAlign="center" 
              fontWeight={600} 
              color='#1F2937'
              fontSize="24px"
            >
              {totalValue}
            </Typography>
            <Typography 
              textAlign="center" 
              fontSize="14px"
              color="#6B7280"
            >
              Indigents
            </Typography>
          </Box>
        </Box>

        {/* Legend */}
        <Box 
          sx={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 3,
            width: '100%',
            maxWidth: '400px',
            mt: 3
          }}
        >
          {chartData.map((entry, index) => (
            <Box 
              key={index} 
              display="flex" 
              alignItems="center"
              justifyContent="space-between"
              gap={2}
            >
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: COLORS[index],
                    flexShrink: 0
                  }}
                />
                <Typography 
                  fontSize="14px"
                  color="#4B5563"
                  sx={{ 
                    whiteSpace: 'nowrap',
                    fontWeight: 500
                  }}
                >
                  {entry.name}
                </Typography>
              </Box>
              <Typography 
                fontSize="14px"
                color="#1F2937"
                fontWeight={600}
              >
                {entry.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </Paper>
  );
};

export default DonutChartCard;
